{
    "DatePattern": "MMM DD, YYYY",
    "NAME": "Date"
}